export default __webpack_public_path__ + "static/media/loader.b3d66ee8.svg";